module.exports = __webpack_public_path__ + "static/media/icon-warranty.15457be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/featured-cards/icons/icon-warranty.png
// module id = 2279
// module chunks = 0